// ********* Delight - Dentist Website is created by Zpunet ******************
// ********* If you get an error please contact us ******
// ******** Email:info@codemarketi.com *********
// ********* Website:www.codemarketi.com *********
// ********* Phone:+255 762 352 746 *********
// ********* Youtub Channel: https://www.youtube.com/channel/UCOYwYO-LEsrjqBs6xXSfq1w *********

// ******** Support my work with *********
// ********* https://www.patreon.com/zpunet *********
// ********* https://www.buymeacoffee.com/zpunet *********

// ********* This is the main component of the website *********

import "./App.css";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import Aos from "aos";
import Toast from "./components/Notifications/Toast";
import {
  AbdmLogin,
  Appointments,
  Campaings,
  Chat,
  CreateInvoice,
  CreatePatient,
  Dashboard,
  DoctorProfile,
  Doctors,
  EditInvoice,
  EditPayment,
  Facility,
  Invoices,
  Login,
  Medicine,
  NewMedicalRecode,
  NotFound,
  Orders,
  OrderDetails,
  CreateOrder,
  PatientProfile,
  Patients,
  Payments,
  Prescription,
  PrescriptionDetail,
  PreviewInvoice,
  PreviewPayment,
  Receptions,
  Services,
  Settings,
  HfrRegisterOTP,
  HfrRegister,
  HfrLogin,
  InviteAcceptance,
  ForgotPassword,
  ResetPassword,
} from "./screens";
import HfrRegisterFacility from "./screens/HfrRegisterFacility";
import DetailedFacility from "./components/DetailedFacility";
import MainHeader from "./Layout/MainHeader";
import FacilityPreview from "./components/FacilityPreview";
import Hfr from "./screens/Hfr";
// import Campaings from "./screens/Campaings";

function App() {
  Aos.init();
  return (
    <>
      {/* Toaster */}
      <Toast />
      {/* Routes */}
      <BrowserRouter>
        {/* this change only for Dont show the MainHeader on Dashboard */}
        <AllAppRoutes />
      </BrowserRouter>
    </>
  );

  function AllAppRoutes() {
    const location = useLocation();
    const headerFromRoutes = ["/", "/hfrLogin", "hfrotp", "login"];

    const ShowHeader = headerFromRoutes.includes(location.pathname);
    return (
      <>
        {ShowHeader && <MainHeader />}
        <Routes>
          <Route path='/dashboard' element={<Dashboard />} />
          <Route path='/' element={<AbdmLogin />} />
          {/* Register Facility */}

          {/* this one I dont know is of any use or not */}
          <Route path='/hfr-register' element={<HfrRegister />} />

          {/* Invitation acceptance route */}
          <Route path='/invite' element={<InviteAcceptance />} />

          <Route path='/hfr-facility' element={<Hfr />} />
          <Route path='/detailed-facility' element={<DetailedFacility />} />

          <Route path='/hfrLogin' element={<HfrLogin />} />
          <Route path='/hfrotp' element={<HfrRegisterOTP />} />
          {/* invoice */}
          <Route path='/invoices' element={<Invoices />} />
          <Route path='/invoices/create' element={<CreateInvoice />} />
          <Route path='/invoices/edit/:id' element={<EditInvoice />} />
          <Route path='/invoices/preview/:id' element={<PreviewInvoice />} />
          {/* payments */}
          <Route path='/payments' element={<Payments />} />
          <Route path='/orders' element={<Orders />} />
          <Route path='/orders/preview/:id' element={<OrderDetails />} />
          <Route path='/orders/create' element={<CreateOrder />} />

          <Route path='/payments/edit/:id' element={<EditPayment />} />
          <Route path='/payments/preview/:id' element={<PreviewPayment />} />
          {/* patient */}
          <Route path='/patients' element={<Patients />} />
          <Route path='/patients/preview/:id' element={<PatientProfile />} />
          <Route path='/patients/create' element={<CreatePatient />} />
          <Route path='/patients/visiting/:id' element={<NewMedicalRecode />} />
          {/* doctors */}
          <Route path='/doctors' element={<Doctors />} />
          <Route path='/doctors/preview/:id' element={<DoctorProfile />} />
          {/* reception */}
          <Route path='/receptions' element={<Receptions />} />
          {/* others */}
          <Route path='/login' element={<Login />} />
          <Route path='/appointments' element={<Appointments />} />
          <Route path='/campaigns' element={<Campaings />} />
          <Route path='/medicine' element={<Medicine />} />
          <Route path='/services' element={<Services />} />
          <Route path='/settings' element={<Settings />} />
          <Route path='/prescription' element={<Prescription />} />
          <Route path='/prescriptiondetail' element={<PrescriptionDetail />} />
          <Route path='/chat' element={<Chat />} />
          <Route path='/facility' element={<Facility />} />
          <Route path='/preview' element={<FacilityPreview />} />

          <Route path='/forgot-password' element={<ForgotPassword />} />
          <Route path='/reset-password' element={<ResetPassword />} />

          <Route path='*' element={<NotFound />} />
        </Routes>
      </>
    );
  }
}
export default App;
